export default "__VITE_ASSET__CnEni0NC__"